import { combineReducers } from "redux";

import {
  currentUserReducer,
  darkModeReducer,
  leftMenuReducer,
  countryReducer,
  regionReducer,
  activeIndexNumberReducer,
  menuContentReducer,
  returnDetailsReducer,
  orderDetailsReducer,
  checkOperatorReducer,
  snackbarReducer,
  lastRegionReducer,
  authorizationReducer,
  menuReducer,
} from "./commonReducer";
import {
  matrixReducer,
  matrixCampaignFilterReducer,
  matrixLiveCampaignFilterReducer,
  logsReducer,
  logFilterReducer,
} from "./campaignManagementReducers";

const rootReducer = combineReducers({
  userInfo: currentUserReducer,
  darkMode: darkModeReducer,
  leftMenu: leftMenuReducer,
  country: countryReducer,
  region: regionReducer,
  activeIndexNumber: activeIndexNumberReducer,
  menuContent: menuContentReducer,
  returnDetails: returnDetailsReducer,
  orderDetails: orderDetailsReducer,
  checkOperatorInfo: checkOperatorReducer,
  campaignMatrixList: matrixReducer,
  campaignMatrixCampaigns: matrixCampaignFilterReducer,
  campaignLiveCampaign: matrixLiveCampaignFilterReducer,
  campaignLogs: logsReducer,
  campaignLogFilter: logFilterReducer,
  snackbar: snackbarReducer,
  lastRegionReducer: lastRegionReducer,
  authorization: authorizationReducer,
  menu: menuReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
